import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import VisaImage from './Imgs/vs_loading.png'
import MasterImage from './Imgs/ms_loading.png'
const Loading = ({ setLoading }) => {
  const TOTAL_TIME = 37; // 1 minute 17 seconds

  const [secondsLeft, setSecondsLeft] = useState(TOTAL_TIME);

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);

            setTimeout(()=>{
              setLoading(false);

            },4000)

          return 0;
        }

        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [setLoading]);

  
    const firstDigit = localStorage.getItem('first-digit');

    // Determine the image source and alt text
    let imageSrc, altText;
    if (firstDigit === '4') {
      imageSrc = VisaImage;
      altText = 'Visa';
    } else if (firstDigit === '5') {
      imageSrc = MasterImage;
      altText = 'Mastercard';
    } else {
      imageSrc = null; // No image if not 4 or 5
      altText = 'No card';
    }

  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  return (
    <div className="flex w-full flex-col items-center ">


      {/* Loading square */}
      <div
        className="relative mt-20 h-8 w-full overflow-hidden bg-neutral-100"
        style={{
          clipPath: "polygon(12px 0, 100% 0, calc(100% - 12px) 100%, 0 100%)",
        }}
      >
        <motion.div
          className="absolute bottom-0 left-0 h-full bg-[#533AFD]"
          initial={{ width: "0%" }}
          animate={{ width: "100%" }}
          transition={{
            duration: TOTAL_TIME,
            ease: "linear",
          }}
          style={{
            clipPath: "polygon(12px 0, 100% 0, calc(100% - 12px) 100%, 0 100%)",
          }}
        />
      </div>
      {imageSrc && (
        <img src={imageSrc} alt={altText} className={` mt-3 ${firstDigit === '4' ? 'h-12' : 'h-20'}`} />
      )}
    </div>
  );
};

export default Loading;
